



























import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {AddressInitState, Amphures, Districts, Provinces} from '@/store/address/address.types';
import {RegisterEnum} from '@/store/auth/auth.enum';
import {Member, PersonEmergencies} from '@/store/member/member.types';

@Component({
  components: {}
})
export default class AddressEmergenciesComponent extends Vue {
  @Prop({default: () => ({} as PersonEmergencies)})
  public PersonEmergencies!: PersonEmergencies;

  @State('address') addressInitState!: AddressInitState;
  @Action('_getProvinces', {namespace: 'address'}) getProvinces!: () => Promise<void>;
  @Action('_getAmphures', {namespace: 'address'}) getAmphures!: (payload: string) => Promise<void>;
  @Action('_getDistricts', {namespace: 'address'}) getDistricts!: (payload: string) => Promise<void>;

  public MemberData = {} as Member;
  public Person = {} as PersonEmergencies;


  async mounted() {
    this.MemberData = await JSON.parse(localStorage.getItem(RegisterEnum.Register) as string) as Member;
    if (this.MemberData.personEmergencies.length !== 0) {
      this.Person = this.MemberData.personEmergencies[0]
    }
  }

  async ChangeData() {
    this.$emit('emergenciesChanged', this.Person);
    // this.MemberData.personEmergencies = [this.Person];
    // let newData = Object.assign(JSON.parse(localStorage.getItem(RegisterEnum.Register) as string)) as Member;
    // newData.personEmergencies = this.MemberData.personEmergencies;
    // setTimeout(() => {
    //   localStorage.setItem(RegisterEnum.Register, JSON.stringify(newData).toString());
    // }, 100);
  }

}
